import BoxFormMultiselect from './BoxFormMultiselect';
import './BoxFormMultiselect.scss';

export default BoxFormMultiselect;
